import { render, staticRenderFns } from "./AppEmbed.vue?vue&type=template&id=81608d4e&scoped=true&"
import script from "./AppEmbed.vue?vue&type=script&lang=js&"
export * from "./AppEmbed.vue?vue&type=script&lang=js&"
import style0 from "./AppEmbed.vue?vue&type=style&index=0&id=81608d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81608d4e",
  null
  
)

export default component.exports